import { Locale as AntLocale } from "antd/lib/locale";
import { Locale } from "../config";

import ru from "antd/locale/ru_RU";
import en from "antd/locale/en_US";
import kk from "antd/locale/kk_KZ";
import uz from "antd/locale/uz_UZ";

// Importing dayjs locales to ensure correct work of date picker and other components
import "dayjs/locale/ru";
import "dayjs/locale/en";
import "dayjs/locale/kk";
import "dayjs/locale/uz";

ru.Form!.defaultValidateMessages.required = "Это обязательное поле";
ru.Form!.defaultValidateMessages.types!.email = "Неверный формат почты";
ru.Form!.defaultValidateMessages.string!.max = () =>
  "Слишком много символов. Максимум ${max}";

en.Form!.defaultValidateMessages.required = "This field is required";

export const messages: Record<Locale, AntLocale> = {
  ru,
  en,
  kz: kk,
  uz,
};
